import { Spin } from "antd";
import _styles from "./Loader.module.scss";
import i18n from "i18next";
import loadingImage from "resources/loading.svg";
import dialogLoadingImage from "resources/DialogLoading.svg";
import Flex from "components/Flex";
import classNames from "classnames/bind";
const styles = classNames.bind(_styles);

export interface LoaderProps {
  mode?: "default" | "keyboard" | "msgLong" | "msgShort";
  size?: "small" | "default" | "large";
  title?: string;
  className?: string;
}

export const Loader =
  ({
    mode: _mode = "default",
    size: _size,
    title: _title,
  }: Pick<LoaderProps, "mode" | "size" | "title"> = {}) =>
  ({
    className,
    title = _title,
    size = _size,
    mode = _mode,
  }: LoaderProps = {}): JSX.Element => {
    return (
      <Flex.Row className={styles(mode, className)} align="center" justify="center">
        <Spin
          size={mode === "msgLong" ? size ?? "large" : size}
          indicator={
            <img src={mode === "default" ? loadingImage : dialogLoadingImage} alt="" />
          }
          className={styles("spinner")}
        />
        {mode === "msgShort" && <Flex.Col flex={1}>{title}</Flex.Col>}
        {mode === "msgLong" && (
          <Flex.Col flex={1}>
            {title && <div className={styles("title")}>{title}</div>}
            <div className={styles("subtitle")}>{i18n.t("widget.preloaderSubtitle")}</div>
          </Flex.Col>
        )}
        {mode === "keyboard" && (
          <Flex.Col flex={1} className={styles("title")}>
            {title ?? i18n.t("widget.preloaderSubtitleShort")}
          </Flex.Col>
        )}
      </Flex.Row>
    );
  };
